// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  padding: 0;
  background: #111111;
  color: #888888;
  font-size: 13px;
}
.footer .content .link {
  margin: 0 auto;
  padding: 12px 30px;
  position: relative;
}
.footer .content .link::before {
  content: " ";
  display: table;
}
.footer .content .link .social {
  float: left;
  padding: 8px 18px;
  color: #ffffff;
  background: #000000;
  margin-top: -28px;
  position: relative;
  display: flex;
  align-items: center;
}
.footer .content .link .social::after {
  border-right: 9px solid #777777;
  border-top: 16px solid transparent;
  content: "";
  display: block;
  height: 0;
  left: -9px;
  position: absolute;
  top: 0;
}
.footer .content .link .social label {
  font-size: 13px;
  margin-right: 10px;
  color: #222222;
}
.footer .content .link .social a {
  margin-right: 5px;
  border: 1px solid #222222;
  padding: 5px;
  border-radius: 50%;
  width: 1.5rem;
  height: 1.5rem;
  font-size: 13px;
  color: #222222;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
}
.footer .content .link .social a:hover {
  color: #ffffff;
  border-color: #ffffff;
}
.footer .info {
  background: #222222;
  border-top: 1px solid #333333;
  padding: 20px 0px;
  font-size: 12px;
}
.footer .info a {
  font-size: 14px;
  font-weight: bold;
  text-decoration: none;
  color: #dddddd;
}
.footer .info a:hover {
  text-decoration: underline;
  color: #ffffff;
}
.footer .info .content {
  display: flex;
  justify-content: space-between;
}
@media (max-width: 991.98px) {
  .footer .info .content {
    flex-wrap: wrap;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/footer/MainFooter.style.scss","webpack://./src/assets/styles/colors.scss","webpack://./src/assets/styles/mixins.scss"],"names":[],"mappings":"AAGA;EACE,UAAA;EACA,mBAAA;EACA,cCHS;EDIT,eAAA;AAFF;AAKI;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;AAHN;AAKM;EACE,YAAA;EACA,cAAA;AAHR;AAMM;EACE,WAAA;EACA,iBAAA;EACA,cCjBA;EDkBA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAJR;AAMQ;EACE,+BAAA;EACA,kCAAA;EACA,WAAA;EACA,cAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,MAAA;AAJV;AAOQ;EACE,eAAA;EACA,kBAAA;EACA,cAAA;AALV;AAQQ;EACE,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,qBAAA;AANV;AAQU;EACE,cCzDJ;ED0DI,qBC1DJ;ADoDR;AAaE;EACE,mBAAA;EACA,6BAAA;EACA,iBAAA;EACA,eAAA;AAXJ;AAaI;EACE,eAAA;EACA,iBAAA;EACA,qBAAA;EACA,cAAA;AAXN;AAaM;EACE,0BAAA;EACA,cC/EA;ADoER;AAeI;EACE,aAAA;EACA,8BAAA;AAbN;AExEI;EFmFA;IAKI,eAAA;EAZN;AACF","sourcesContent":["@import \"../../assets/styles/mixins.scss\";\r\n@import \"../../assets/styles/colors.scss\";\r\n\r\n.footer {\r\n  padding: 0;\r\n  background: #111111;\r\n  color: $neutral8;\r\n  font-size: 13px;\r\n\r\n  .content {\r\n    .link {\r\n      margin: 0 auto;\r\n      padding: 12px 30px;\r\n      position: relative;\r\n\r\n      &::before {\r\n        content: \" \";\r\n        display: table;\r\n      }\r\n\r\n      .social {\r\n        float: left;\r\n        padding: 8px 18px;\r\n        color: $white;\r\n        background: #000000;\r\n        margin-top: -28px;\r\n        position: relative;\r\n        display: flex;\r\n        align-items: center;\r\n\r\n        &::after {\r\n          border-right: 9px solid $neutral7;\r\n          border-top: 16px solid transparent;\r\n          content: \"\";\r\n          display: block;\r\n          height: 0;\r\n          left: -9px;\r\n          position: absolute;\r\n          top: 0;\r\n        }\r\n\r\n        label {\r\n          font-size: 13px;\r\n          margin-right: 10px;\r\n          color: #222222;\r\n        }\r\n\r\n        a {\r\n          margin-right: 5px;\r\n          border: 1px solid #222222;\r\n          padding: 5px;\r\n          border-radius: 50%;\r\n          width: 1.5rem;\r\n          height: 1.5rem;\r\n          font-size: 13px;\r\n          color: #222222;\r\n          text-align: center;\r\n          display: flex;\r\n          justify-content: center;\r\n          align-items: center;\r\n          text-decoration: none;\r\n\r\n          &:hover {\r\n            color: $white;\r\n            border-color: $white;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .info {\r\n    background: #222222;\r\n    border-top: 1px solid #333333;\r\n    padding: 20px 0px;\r\n    font-size: 12px;\r\n\r\n    a {\r\n      font-size: 14px;\r\n      font-weight: bold;\r\n      text-decoration: none;\r\n      color: #dddddd;\r\n\r\n      &:hover {\r\n        text-decoration: underline;\r\n        color: $white;\r\n      }\r\n    }\r\n\r\n    .content {\r\n      display: flex;\r\n      justify-content: space-between;\r\n\r\n      @include md {\r\n        flex-wrap: wrap;\r\n      }\r\n    }\r\n  }\r\n}\r\n","$neutral0: #000000;\r\n$neutral3: #333333;\r\n$neutral7: #777777;\r\n$neutral8: #888888;\r\n$neutral9: #999999;\r\n\r\n$white: #ffffff;\r\n\r\n$orange1: #ff6600;\r\n$orange2: #f48f40;\r\n","@import 'variables.scss';\r\n\r\n@mixin responsive($breakpoint) {\r\n  $breakpoint-value: map-get($breakpoints, $breakpoint);\r\n  \r\n  @if $breakpoint-value != null {\r\n    @media (max-width: $breakpoint-value) {\r\n      @content;\r\n    }\r\n  } @else {\r\n    @warn \"No value found for breakpoint: #{$breakpoint}\";\r\n  }\r\n}\r\n\r\n// mixins for each breakpoint\r\n@mixin xs {\r\n  @include responsive(screen-xs) {\r\n    @content;\r\n  }\r\n}\r\n\r\n@mixin sm {\r\n  @include responsive(screen-sm) {\r\n    @content;\r\n  }\r\n}\r\n\r\n@mixin md {\r\n  @include responsive(screen-md) {\r\n    @content;\r\n  }\r\n}\r\n\r\n@mixin lg {\r\n  @include responsive(screen-lg) {\r\n    @content;\r\n  }\r\n}\r\n\r\n@mixin xl {\r\n  @include responsive(screen-xl) {\r\n    @content;\r\n  }\r\n}\r\n\r\n@mixin xxl {\r\n  @include responsive(screen-xxl) {\r\n    @content;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
